import { eACHDisbursementCategories } from '../eEscrowAchPushDisbursementCategories';
import { UUID } from '../../../shared/UUID';
import { IAchPushDisbursementData } from '../IAchPushDisbursementData';

// from swagger docs
export interface IAchPushDisbursementRequest {
  amountCents: number;
  category: eACHDisbursementCategories;
  ownerId?: UUID;
  achAccountId?: UUID;
  wellsFargoTransactionNumber?: string;
}

export interface IAchPushDisbursementRequestWithId extends IAchPushDisbursementRequest {
  id: UUID;
}

export const convertIAchPushDisbursementDataToIAchPushDisbursementRequestWithId = ({
  id,
  ownerId,
  amountCents,
  category,
  wellsFargoTransactionNumber,
  account,
}: IAchPushDisbursementData): IAchPushDisbursementRequestWithId => ({
  id,
  ownerId,
  amountCents,
  achAccountId: account?.id ?? '',
  //despite the ||, the form validation *should* enforce the presence of the category.
  category: category ?? eACHDisbursementCategories.ThirdParty,
  wellsFargoTransactionNumber,
});
